import React from 'react'
import classNames from 'classnames'
import SliderWithScrollLock from '#src/components/SliderWithScrollLock'
import { Image } from '@deal/components'
import { MediaFileFragment } from '#src/generated/graphql'
import styles from './styles.css'

interface ImageCarouselThumbnailsProps {
  currentSlide: number
  onNavigateToSlide: (index: number) => void
  images: MediaFileFragment[]
}

const ImageCarouselThumbnails: React.SFC<ImageCarouselThumbnailsProps> = ({
  images,
  currentSlide,
  onNavigateToSlide
}) => {
  return (
    <div className={styles.thumbnails}>
      <SliderWithScrollLock
        slidesToShow={5}
        arrows={false}
        vertical={true}
        infinite={false}
        className={styles.slider}
      >
        {images.map((image, index) => (
          <div key={index} className={styles.itemContainer}>
            <Image
              src={image.url}
              lazyLoad={false}
              width={80}
              height={80}
              imgixParams={{
                fit: 'crop'
              }}
              className={classNames(styles.thumbnail, {
                [styles.active]: currentSlide === index
              })}
              htmlAttributes={{
                onClick: () => onNavigateToSlide(index)
              }}
            />
          </div>
        ))}
      </SliderWithScrollLock>
    </div>
  )
}

export default ImageCarouselThumbnails
